/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddQualityGradingModel} from '../bioplanModels';
// @ts-ignore
import type {CopyQualityGradingModel} from '../bioplanModels';
// @ts-ignore
import type {QualityGradingModel} from '../bioplanModels';
/**
 * QualityGradingModelsApi - axios parameter creator
 * @export
 */
export const QualityGradingModelsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Copy a quality grading model
     * @param {CopyQualityGradingModel} copyQualityGradingModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsCopyPost: async (
      copyQualityGradingModel: CopyQualityGradingModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'copyQualityGradingModel' is not null or undefined
      assertParamExists('qualityGradingModelsCopyPost', 'copyQualityGradingModel', copyQualityGradingModel);
      const localVarPath = `/qualityGradingModels/copy`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        copyQualityGradingModel,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsGet: async (planId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('qualityGradingModelsGet', 'planId', planId);
      const localVarPath = `/qualityGradingModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete quality grading model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsModelIdDelete: async (
      modelId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('qualityGradingModelsModelIdDelete', 'modelId', modelId);
      const localVarPath = `/qualityGradingModels/{modelId}`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get quality grading model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsModelIdGet: async (
      modelId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('qualityGradingModelsModelIdGet', 'modelId', modelId);
      const localVarPath = `/qualityGradingModels/{modelId}`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update quality grading model
     * @param {string} modelId
     * @param {QualityGradingModel} qualityGradingModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsModelIdPut: async (
      modelId: string,
      qualityGradingModel: QualityGradingModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'modelId' is not null or undefined
      assertParamExists('qualityGradingModelsModelIdPut', 'modelId', modelId);
      // verify required parameter 'qualityGradingModel' is not null or undefined
      assertParamExists('qualityGradingModelsModelIdPut', 'qualityGradingModel', qualityGradingModel);
      const localVarPath = `/qualityGradingModels/{modelId}`.replace(
        `{${'modelId'}}`,
        encodeURIComponent(String(modelId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(qualityGradingModel, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create quality grading model for user\'s plan
     * @param {AddQualityGradingModel} addQualityGradingModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsPost: async (
      addQualityGradingModel: AddQualityGradingModel,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addQualityGradingModel' is not null or undefined
      assertParamExists('qualityGradingModelsPost', 'addQualityGradingModel', addQualityGradingModel);
      const localVarPath = `/qualityGradingModels/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        addQualityGradingModel,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QualityGradingModelsApi - functional programming interface
 * @export
 */
export const QualityGradingModelsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = QualityGradingModelsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Copy a quality grading model
     * @param {CopyQualityGradingModel} copyQualityGradingModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelsCopyPost(
      copyQualityGradingModel: CopyQualityGradingModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelsCopyPost(
        copyQualityGradingModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelsApi.qualityGradingModelsCopyPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QualityGradingModel>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelsApi.qualityGradingModelsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete quality grading model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelsModelIdDelete(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelsModelIdDelete(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelsApi.qualityGradingModelsModelIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get quality grading model by its identifier
     * @param {string} modelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelsModelIdGet(
      modelId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelsModelIdGet(modelId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelsApi.qualityGradingModelsModelIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update quality grading model
     * @param {string} modelId
     * @param {QualityGradingModel} qualityGradingModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelsModelIdPut(
      modelId: string,
      qualityGradingModel: QualityGradingModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelsModelIdPut(
        modelId,
        qualityGradingModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelsApi.qualityGradingModelsModelIdPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create quality grading model for user\'s plan
     * @param {AddQualityGradingModel} addQualityGradingModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelsPost(
      addQualityGradingModel: AddQualityGradingModel,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelsPost(
        addQualityGradingModel,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelsApi.qualityGradingModelsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QualityGradingModelsApi - factory interface
 * @export
 */
export const QualityGradingModelsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QualityGradingModelsApiFp(configuration);
  return {
    /**
     *
     * @summary Copy a quality grading model
     * @param {QualityGradingModelsApiQualityGradingModelsCopyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsCopyPost(
      requestParameters: QualityGradingModelsApiQualityGradingModelsCopyPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModel> {
      return localVarFp
        .qualityGradingModelsCopyPost(requestParameters.copyQualityGradingModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QualityGradingModelsApiQualityGradingModelsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsGet(
      requestParameters: QualityGradingModelsApiQualityGradingModelsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<QualityGradingModel>> {
      return localVarFp
        .qualityGradingModelsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete quality grading model by its identifier
     * @param {QualityGradingModelsApiQualityGradingModelsModelIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsModelIdDelete(
      requestParameters: QualityGradingModelsApiQualityGradingModelsModelIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .qualityGradingModelsModelIdDelete(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get quality grading model by its identifier
     * @param {QualityGradingModelsApiQualityGradingModelsModelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsModelIdGet(
      requestParameters: QualityGradingModelsApiQualityGradingModelsModelIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModel> {
      return localVarFp
        .qualityGradingModelsModelIdGet(requestParameters.modelId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update quality grading model
     * @param {QualityGradingModelsApiQualityGradingModelsModelIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsModelIdPut(
      requestParameters: QualityGradingModelsApiQualityGradingModelsModelIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModel> {
      return localVarFp
        .qualityGradingModelsModelIdPut(requestParameters.modelId, requestParameters.qualityGradingModel, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create quality grading model for user\'s plan
     * @param {QualityGradingModelsApiQualityGradingModelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsPost(
      requestParameters: QualityGradingModelsApiQualityGradingModelsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModel> {
      return localVarFp
        .qualityGradingModelsPost(requestParameters.addQualityGradingModel, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for qualityGradingModelsCopyPost operation in QualityGradingModelsApi.
 * @export
 * @interface QualityGradingModelsApiQualityGradingModelsCopyPostRequest
 */
export interface QualityGradingModelsApiQualityGradingModelsCopyPostRequest {
  /**
   *
   * @type {CopyQualityGradingModel}
   * @memberof QualityGradingModelsApiQualityGradingModelsCopyPost
   */
  readonly copyQualityGradingModel: CopyQualityGradingModel;
}

/**
 * Request parameters for qualityGradingModelsGet operation in QualityGradingModelsApi.
 * @export
 * @interface QualityGradingModelsApiQualityGradingModelsGetRequest
 */
export interface QualityGradingModelsApiQualityGradingModelsGetRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelsApiQualityGradingModelsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for qualityGradingModelsModelIdDelete operation in QualityGradingModelsApi.
 * @export
 * @interface QualityGradingModelsApiQualityGradingModelsModelIdDeleteRequest
 */
export interface QualityGradingModelsApiQualityGradingModelsModelIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelsApiQualityGradingModelsModelIdDelete
   */
  readonly modelId: string;
}

/**
 * Request parameters for qualityGradingModelsModelIdGet operation in QualityGradingModelsApi.
 * @export
 * @interface QualityGradingModelsApiQualityGradingModelsModelIdGetRequest
 */
export interface QualityGradingModelsApiQualityGradingModelsModelIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelsApiQualityGradingModelsModelIdGet
   */
  readonly modelId: string;
}

/**
 * Request parameters for qualityGradingModelsModelIdPut operation in QualityGradingModelsApi.
 * @export
 * @interface QualityGradingModelsApiQualityGradingModelsModelIdPutRequest
 */
export interface QualityGradingModelsApiQualityGradingModelsModelIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelsApiQualityGradingModelsModelIdPut
   */
  readonly modelId: string;

  /**
   *
   * @type {QualityGradingModel}
   * @memberof QualityGradingModelsApiQualityGradingModelsModelIdPut
   */
  readonly qualityGradingModel: QualityGradingModel;
}

/**
 * Request parameters for qualityGradingModelsPost operation in QualityGradingModelsApi.
 * @export
 * @interface QualityGradingModelsApiQualityGradingModelsPostRequest
 */
export interface QualityGradingModelsApiQualityGradingModelsPostRequest {
  /**
   *
   * @type {AddQualityGradingModel}
   * @memberof QualityGradingModelsApiQualityGradingModelsPost
   */
  readonly addQualityGradingModel: AddQualityGradingModel;
}

/**
 * QualityGradingModelsApi - object-oriented interface
 * @export
 * @class QualityGradingModelsApi
 * @extends {BaseAPI}
 */
export class QualityGradingModelsApi extends BaseAPI {
  /**
   *
   * @summary Copy a quality grading model
   * @param {QualityGradingModelsApiQualityGradingModelsCopyPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelsApi
   */
  public qualityGradingModelsCopyPost(
    requestParameters: QualityGradingModelsApiQualityGradingModelsCopyPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelsApiFp(this.configuration)
      .qualityGradingModelsCopyPost(requestParameters.copyQualityGradingModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QualityGradingModelsApiQualityGradingModelsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelsApi
   */
  public qualityGradingModelsGet(
    requestParameters: QualityGradingModelsApiQualityGradingModelsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelsApiFp(this.configuration)
      .qualityGradingModelsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete quality grading model by its identifier
   * @param {QualityGradingModelsApiQualityGradingModelsModelIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelsApi
   */
  public qualityGradingModelsModelIdDelete(
    requestParameters: QualityGradingModelsApiQualityGradingModelsModelIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelsApiFp(this.configuration)
      .qualityGradingModelsModelIdDelete(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get quality grading model by its identifier
   * @param {QualityGradingModelsApiQualityGradingModelsModelIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelsApi
   */
  public qualityGradingModelsModelIdGet(
    requestParameters: QualityGradingModelsApiQualityGradingModelsModelIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelsApiFp(this.configuration)
      .qualityGradingModelsModelIdGet(requestParameters.modelId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update quality grading model
   * @param {QualityGradingModelsApiQualityGradingModelsModelIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelsApi
   */
  public qualityGradingModelsModelIdPut(
    requestParameters: QualityGradingModelsApiQualityGradingModelsModelIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelsApiFp(this.configuration)
      .qualityGradingModelsModelIdPut(requestParameters.modelId, requestParameters.qualityGradingModel, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create quality grading model for user\'s plan
   * @param {QualityGradingModelsApiQualityGradingModelsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelsApi
   */
  public qualityGradingModelsPost(
    requestParameters: QualityGradingModelsApiQualityGradingModelsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelsApiFp(this.configuration)
      .qualityGradingModelsPost(requestParameters.addQualityGradingModel, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
